module.exports = __webpack_public_path__ + "static/reference.5a35ad81.png";